import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { LazyDiv } from 'components/common/LazyHtml'

const BOTArticlesCustomText = ({ content = []}) =>
  <Wrapper>
    {
      content.map(({ content }) => <LazyDiv content={ content } />)
    }
  </Wrapper>

BOTArticlesCustomText.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
}

BOTArticlesCustomText.type = 'BOTArticlesCustomText'

export default BOTArticlesCustomText

const Wrapper = styled.div`
  line-height: 1.5;
  ${Mixin.responsive('margin', '50px auto 0', '50px 16px -20px')}
  ${Media.tablet`
    padding: 0 16px;
  `}
`
